export default "__VITE_ASSET__QZR7Ut4___"